import { AuthService } from './auth';
import { AuthUserService } from './user';
import { VerificationCodeService } from './verificationCode';
var ApiSettings = /** @class */ (function () {
    function ApiSettings() {
    }
    Object.defineProperty(ApiSettings.prototype, "BaseUrl", {
        set: function (url) {
            this.baseUrl = url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiSettings.prototype, "ServiceUrl", {
        get: function () {
            return this.baseUrl;
        },
        enumerable: false,
        configurable: true
    });
    return ApiSettings;
}());
export var apiSettings = new ApiSettings();
export var authService = new AuthService();
export var userService = new AuthUserService();
export var verificationCodeService = new VerificationCodeService();
